import { render, staticRenderFns } from "./SntColorPicker.vue?vue&type=template&id=5b984fe3&scoped=true&"
import script from "./SntColorPicker.vue?vue&type=script&lang=js&"
export * from "./SntColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./SntColorPicker.vue?vue&type=style&index=0&id=5b984fe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b984fe3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VColorPicker,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b984fe3')) {
      api.createRecord('5b984fe3', component.options)
    } else {
      api.reload('5b984fe3', component.options)
    }
    module.hot.accept("./SntColorPicker.vue?vue&type=template&id=5b984fe3&scoped=true&", function () {
      api.rerender('5b984fe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/SntColorPicker.vue"
export default component.exports